import { render, staticRenderFns } from "./DiagnosticRecord.vue?vue&type=template&id=b060ac5e&scoped=true"
import script from "./DiagnosticRecord.vue?vue&type=script&lang=js"
export * from "./DiagnosticRecord.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticRecord.vue?vue&type=style&index=0&id=b060ac5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b060ac5e",
  null
  
)

export default component.exports